import styled from '@emotion/styled'

import { Heading3, Heading6 } from '~/theme/utils/typography'
import { mediaQueryUp } from '~/utils/grid'

export const ReservationExpiredWrapper = styled.div`
  background: ${({ theme }) => theme.colors.layoutBg};

  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};

  display: grid;
  justify-items: center;
  row-gap: 2rem;
  width: 100%;

  padding: 1.5rem 1rem;

  ${mediaQueryUp('m')} {
    max-width: 720px;
    margin: 2.5rem auto 0;
    padding: 3rem 2.5rem;
  }
`

export const ReservationExpiredTitle = styled(Heading3)`
  font-weight: 600;
`

export const ReservationExpiredContent = styled(Heading6)`
  text-align: center;
  white-space: pre-line;
  span {
    font-weight: 600;
  }
`

export const ReservationExpiredActions = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;

  flex-direction: column;

  ${mediaQueryUp('m')} {
    flex-direction: row;
  }
`
